export interface SupplierPurchaseOrderHistory {
  id: string;
  orderNo: string;
  orderDate: Date;
  supplierOrderRef: string;
  supplierOrderNo: string;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  orderStatus: string;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
  currencyCode: string;
  currencySymbol: string;
}
